// extracted by mini-css-extract-plugin
export default {"list":"EstudianteLista_list__Hh6w0"};